import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'gatsby';


const Navbar = () => {
  return (
    <nav className="navbar navbar-static-bottom">
      <Container>
       <Link activeClassName="active" to={'/'} smooth='true' duration={1000}>
                  Orchan Magramov
          </Link>
              <Link activeClassName="active" to="/about" smooth='true' duration={1000}>
                  About
          </Link>
              <Link activeClassName="active" to="/contact" smooth='true' duration={1000}>
                  Contact
          </Link>
      </Container>
    </nav>
  );
};

export default Navbar;
